var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLeftActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 18.75L8.625 20.25L0.75 12.375L8.625 4.5L10.125 6L3.75 12.375L10.125 18.75Z",
    fill: "#89A6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.75L15.375 20.25L7.5 12.375L15.375 4.5L16.875 6L10.5 12.375L16.875 18.75Z",
    fill: "#89A6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.2529H9.375V13.5029H23.625V11.2529Z",
    fill: "#89A6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftActive);
export default __webpack_public_path__ + "static/media/double-left-active.92048e062764270dcf74ea02a3cf8fb1.svg";
export { ForwardRef as ReactComponent };